import {emotionStyled, tokens} from '@packages/utilities/styled';

import {DragItemHandle} from '../DragItem/DragItemHandle';

export const RowItemContainer = emotionStyled('div')(
  {
    position: 'relative',
    [`& ${DragItemHandle}`]: {
      paddingLeft: tokens.ui.rowItem.dragHandle.paddingLeft,
    },
    [`&:has(:focus-visible) ${DragItemHandle}, &:hover ${DragItemHandle}`]: {
      opacity: 1,
    },
  },
  {
    componentName: 'RowItemContainer',
    variants: {
      isDragging: {
        true: {
          opacity: 0.2,
        },
      },
      isCheckbox: {
        true: {
          [`${DragItemHandle}`]: {
            width: tokens.ui.rowItem.dragHandle.checkboxHandleWidth,
          },
        },
      },
    },
  }
);

/**
 * Selectors used to determine whether a RowItem is in its "active" state.
 * This is used to show `RowItemActions` and change the color of the `RowItemBody` icon.
 */
export const RowItemActiveSelectors = (prefix: string | undefined = '') => `
  ${RowItemContainer}${prefix}:not([data-disabled="true"]):hover &, 
  ${RowItemContainer}${prefix}:not([data-disabled="true"]):has(:focus-visible) &, 
  ${RowItemContainer}${prefix}:not([data-disabled="true"]):has(*[aria-expanded="true"]) &, 
  ${RowItemContainer}${prefix}:not([data-disabled="true"])[data-active="true"] &`;
